import _ from 'lodash'

export default {
  filters: {
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は
    // 第2引数（unregisteredValue）+ '未登録' を返却する
    // それ以外の場合は 第3引数(prefix) + 第1引数（label）+ 第4引数（suffix）を返却する
    // 第5引数はlabelが無効の時に未登録を付与するかどうか
    parseBlankForDefaultValue (label, unregisteredValue = '', prefix = '', suffix = '', isUnregisteredLabel = true) {
      return label ? prefix + label + suffix : isUnregisteredLabel ? unregisteredValue + '未登録' : unregisteredValue
    }
  },
  methods: {
    getNameOrUndefined (val, path) {
      return _.get(val, path)
    }
  }
}
